import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, /*#__PURE__*/_toDisplayString(`Tracking number: `), -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Shipping title:", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Status:", -1)
const _hoisted_19 = {
  key: 2,
  class: "my-1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Revenue:", -1)
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Note:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.item.trackingNumber || _ctx.item?.trackingNumbers?.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _hoisted_3,
            (_ctx.item.trackingNumbers?.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.trackingNumbers, (trackingNum, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      _createElementVNode("a", {
                        href: `https://t.17track.net/en#nums=${trackingNum}`,
                        target: "blank",
                        class: "text-blue-600"
                      }, [
                        (index < _ctx.item.trackingNumbers.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(trackingNum + ', '), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(trackingNum), 1))
                      ], 8, _hoisted_5)
                    ]))
                  }), 128))
                ]))
              : (_ctx.item.trackingNumber)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createElementVNode("a", {
                      href: `https://t.17track.net/en#nums=${_ctx.item.trackingNumber}`,
                      target: "blank",
                      class: "text-blue-600"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.item.trackingNumber), 1)
                    ], 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item.carrier || _ctx.item?.carriers?.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _hoisted_11,
            (_ctx.item.carriers?.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.item.carriers.join(', ')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.item.carrier), 1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.item.shippingTitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.item.shippingTitle), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item.status && _ctx.userType === 'agency')
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_tag, {
              type: _ctx.getOrderStatusColor(_ctx.item.status),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.status), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.item.price > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(_ctx.formatterDollars(_ctx.item.price * _ctx.item.quantity)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_ctx.item.note)
        ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.item.note), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}